import { useContext } from 'react'
import { DataManagementHeaderSlotContext } from './DataManagementHeaderSlotContext'

export function useDataManagementHeaderSlot() {
    return useContext(DataManagementHeaderSlotContext)
}
